import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const values = [
  { t: "Confianza", d: "Trabajamos con transparencia y te decimos siempre lo que creemos mejor para tu empresa, aunque no sea lo más fácil de oír." },
  { t: "Compromiso", d: "Nos implicamos en tu negocio como si fuera el nuestro. Tu resultado es nuestro objetivo." },
  { t: "Entendimiento del negocio", d: "Antes de proponer nada, dedicamos tiempo a entender de verdad cómo funciona tu empresa y qué necesitas." },
  { t: "Relaciones a largo plazo", d: "No buscamos un proyecto puntual, sino acompañarte y crecer contigo durante años." },
];

export default function About() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="about-page">
      <section className="pt-36 md:pt-48 pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <motion.div initial="hidden" animate="visible" variants={stagger}>
            <motion.div variants={fadeUp} className="text-xs uppercase tracking-[0.25em] text-[#0B1F3A]/60 mb-6">Sobre Medite Group</motion.div>
            <motion.h1 variants={fadeUp} className="text-5xl md:text-7xl lg:text-8xl text-[#0B1F3A] tracking-tight leading-[0.98] max-w-4xl">Tu socio estratégico a largo plazo.</motion.h1>
          </motion.div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-20 md:pb-28">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport}
          className="rounded-[2rem] overflow-hidden h-[46vh] md:h-[64vh]">
          <img src="https://images.pexels.com/photos/6950031/pexels-photo-6950031.jpeg" alt="Equipo de Medite Group trabajando" className="w-full h-full object-cover" />
        </motion.div>
      </section>

      <section className="bg-[#F3F4F6]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport} className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.25em] text-[#0B1F3A]/60 mb-5">Nuestra convicción</div>
            <h2 className="text-4xl md:text-5xl font-serif text-[#0B1F3A] leading-[1.05]">No vendemos servicios. Resolvemos retos y nos convertimos en parte de tu negocio.</h2>
          </motion.div>
          <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewport} className="lg:col-span-6 lg:col-start-7 space-y-6 text-lg text-gray-600 leading-relaxed">
            <motion.p variants={fadeUp}>Medite Group nace de una idea sencilla: cualquier pequeña o mediana empresa merece contar con el mismo nivel de estrategia y acompañamiento que las grandes compañías, pero explicado de forma clara y adaptado a su realidad.</motion.p>
            <motion.p variants={fadeUp}>Trabajamos codo con codo con propietarios, gerentes y equipos de todo tipo de sectores: restaurantes, talleres, clínicas, despachos, comercios, construcción, industria o ecommerce. Hablamos tu idioma, no el de los tecnicismos.</motion.p>
            <motion.p variants={fadeUp}>No buscamos proyectos de usar y tirar. Queremos convertirnos en tu socio de confianza a largo plazo, ese equipo al que llamas cuando tienes que tomar una decisión importante para tu empresa.</motion.p>
          </motion.div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-36">
        <div className="text-xs uppercase tracking-[0.25em] text-[#0B1F3A]/60 mb-12">Cómo trabajamos</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          {values.map((v, i) => (
            <motion.div key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="visible" viewport={viewport}
              data-testid={`value-${i}`} className="border-t border-gray-200 pt-6">
              <h3 className="text-2xl font-serif text-[#0B1F3A] mb-3">{v.t}</h3>
              <p className="text-gray-600 leading-relaxed max-w-md">{v.d}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="bg-[#0B1F3A] text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
          <h2 className="text-4xl md:text-6xl font-serif tracking-tight max-w-3xl mx-auto leading-[1.05]">Hablemos de hacia dónde va tu empresa.</h2>
          <Link to="/contact" data-testid="about-cta" className="mt-10 inline-flex items-center gap-2 rounded-full bg-white text-[#0B1F3A] px-8 py-4 font-medium hover:scale-[1.03] transition-transform">
            Solicitar un diagnóstico inicial <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </motion.div>
  );
}
